import script from "./CardTank.vue?vue&type=script&setup=true&lang=js"
export * from "./CardTank.vue?vue&type=script&setup=true&lang=js"

import "./CardTank.vue?vue&type=style&index=0&id=44c4e410&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c4e410"]])

export default __exports__